/**
 * Карта v3 — клиент API. Ходит только в /api/map3 через общий axios-инстанс,
 * где перехватчик подставляет токен и обрабатывает 401.
 */
import axios from '../api/axios';

export async function loadState(sceneId) {
  const { data } = await axios.get('/map3/state', { params: sceneId ? { scene_id: sceneId } : {} });
  return data;
}

export async function saveItems(sceneId, docVersion, items, remove = []) {
  const { data } = await axios.post('/map3/items/bulk', {
    scene_id: sceneId,
    doc_version: docVersion,
    items,
    remove,
  });
  return data;
}

export async function listScenes() {
  const { data } = await axios.get('/map3/scenes');
  return data;
}

export async function createScene(name, copyFrom) {
  const { data } = await axios.post('/map3/scenes', { name, copy_from: copyFrom || null, settings: {} });
  return data;
}

export async function deleteScene(id) {
  await axios.delete(`/map3/scenes/${id}`);
}

export async function resetItems(sceneId, kind) {
  const { data } = await axios.delete('/map3/items', { params: { scene_id: sceneId, ...(kind ? { kind } : {}) } });
  return data;
}

/** Загрузка своей картинки устройства (тот же эндпоинт, что и в карточке). */
export async function uploadDeviceImage(deviceId, file) {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await axios.post(`/devices/${deviceId}/image`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteDeviceImage(deviceId) {
  await axios.delete(`/devices/${deviceId}/image`);
}
